<template>
  <md-popup
    v-bind="$attrs"
    v-on="$listeners"
  >
    <md-number-keyboard
      v-bind="$attrs"
      ref="NumberKeyboard"
      class="password-popup"
      :is-hide-confirm="true"
      type="simple"
      v-on="$listeners"
      @enter="handleEnterValue"
      @delete="handleDeleteValue"
    >
      <div class="keyboard-header-warp">
        <div class="keyboard-header">
          <md-icon
            class="my_icon"
            name="close"
            size="lg"
            @click="$emit('input', false)"
          />
          <div class="keyboard-title">{{ $t('paymentPassword') }}</div>
        </div>

        <InputCode :password="code" />

        <div v-if="error" class="error-view">{{ error }}</div>
      </div>
    </md-number-keyboard>
  </md-popup>
</template>

<script>
import InputCode from '@/components/InputCode'
import { NumberKeyboard, Icon, Popup } from 'mand-mobile'
import { setTransactionPassMd5 } from '@/utils/safe'

// 交易密码校验键盘
export default {
  name: 'PasswordPopup',

  components: {
    [NumberKeyboard.name]: NumberKeyboard,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    InputCode
  },

  props: {
    // 报错文案，不为空即展示报错样式 .sync双向绑定
    error: {
      type: String,
      default: ''
    },
    // 输入框内的code .sync双向绑定
    code: {
      type: String,
      default: ''
    }
  },

  watch: {
    '$attrs.value' (val) {
      if (!val) {
        this.$emit('update:error', '')
        this.$emit('update:code', '')
      }
    }
  },

  mounted () {
    // document.querySelector('body').appendChild(this.$el)
  },

  methods: {
    handleEnterValue (value) {
      if (this.code.length >= 6) return

      const newCode = `${this.code}${value}`

      this.$emit('update:code', newCode)

      if (newCode.length === 6) this.handleConfirm(newCode)
    },
    handleDeleteValue () {
      this.$emit('update:code', this.code.substring(0, this.code.length - 1))
    },
    handleConfirm (newCode) {
      this.$emit('finished', setTransactionPassMd5(newCode))
    }
  }
}
</script>

<style scoped lang="scss">
.password-popup {
  ::v-deep .md-popup-box {
    border-radius: 32px 32px 0 0;
  }
}

.keyboard-header-warp {
  padding: 48px 38px;
  background: #fff;

  .keyboard-header {
    display: flex;
    margin-bottom: 44px;
    color: #333;
    font-size: 32px;
  }

  .keyboard-title {
    flex: 1;
    text-align: center;
  }
}

.error-view {
  margin-top: 42px;
  text-align: center;
  color: #fa5151;
}
</style>
